

import { getAuth } from "@firebase/auth";

export default defineNuxtRouteMiddleware((to, from) => {
  const auth = getAuth()
  const claims = useState<Record<string, any>>('claims')

  const protectedRoutes = ['/admin', '/data-deletion' ]// add more routes here

  if (auth.currentUser) {
		console.log('user is signed in')
    // ignore
    if(to.path.includes('/admin') && claims.value?.admin !== true) {
      console.log('user is admin', to.path)
     
      return navigateTo( encodeURI('/error?message=no admin rights'))
    }
		return

  } else {
		// ceck if to.path starts with any protectRoutes
		if(protectedRoutes.some(route => 
			// check if route to.path contains route
			to.path.includes(route))){
			console.log('user is not signed in', to.path)
      return navigateTo('/login?redirect=' + to.path)
    }
  }
})